module.exports = {"svg":{"$":{"t":"1510727546462","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1764","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"32","height":"32"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M463.3 958.3V772.1H228.8v-77.5h234.5v-80.5H228.8v-83.5H420L191.5 128h113.7L469 420.6c18.2 33.4 32.4 62.4 42.7 86.9 9-19.8 24.6-50.5 46.8-92.1L713.9 128h120.8L605.5 530.6h192.9v83.5H564.9v80.5h233.5v77.5H564.9v186.2H463.3z","p-id":"1765"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/money.svg
// module id = FF4x
// module chunks = 15